import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lib-athlete-photo',
  templateUrl: './athlete-photo.component.html',
  styleUrls: ['./athlete-photo.component.scss']
})
export class AthletePhotoComponent implements OnInit {
  @Input()
  id:string;
  @Input()
  isTeam:boolean;
  constructor() {
   }

  ngOnInit() {
    if(this.id==undefined){
      throw new Error("property input id it's not defined please bind property <lib-athlete-photo [id]='your-data'")
    }
    if(this.isTeam==undefined){
      throw new Error("property input isTeam it's not defined please bind property <lib-athlete-photo [isTeam]='your-data'")
    }
  }

}
